import linkedAccountsComponent from './linked-accounts.component';

const linkedAccountsModule = angular.module('linkedAccounts', [
])
  .component('linkedAccounts', linkedAccountsComponent)
  .name;

export default linkedAccountsModule;
